import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const SettingsCtx = createContext(null);

const FALLBACK = {
  church_name: "Sweet Embrace Church",
  short_name: "Sweet Embrace",
  tagline: "A church in Asheville, NC · Est. 2008",
  hero_headline: "You are held by a sweet, stubborn grace.",
  hero_subhead: "We are a community shaped by Scripture, prayer, and a long table.",
  sunday_service_1: "9:00 AM",
  sunday_service_2: "11:00 AM",
  midweek_label: "Mid-week Prayer",
  midweek_time: "Wednesday · 7:00 PM",
  midweek_location: "The Chapel",
  address_line1: "412 Olive Branch Lane",
  address_line2: "Asheville, NC 28801",
  phone: "",
  email: "",
  office_hours: "",
  footer_blurb: "",
  quote: "",
  quote_attribution: "",
  instagram_url: "",
  facebook_url: "",
  youtube_url: "",
  about_eyebrow: "About Sweet Embrace",
  about_headline: "A long table. A patient gospel. A practiced hospitality.",
  about_intro_p1: "",
  about_intro_p2: "",
  beliefs_eyebrow: "What we believe",
  beliefs_headline: "Four rhythms that shape our life.",
  belief_1_title: "Word", belief_1_text: "",
  belief_2_title: "Table", belief_2_text: "",
  belief_3_title: "Prayer", belief_3_text: "",
  belief_4_title: "Sent", belief_4_text: "",
  pastors_eyebrow: "Pastors & Leadership",
  pastors_headline: "The people who carry the load.",
  home_hero_image_url: "", home_community_image_url: "",
  home_sermon_eyebrow: "This Week's Message",
  home_sermon_cta: "View the full library",
  home_doors_eyebrow: "Where to begin",
  home_doors_headline: "Three quiet doors into our life together.",
  home_tile_prayer_title: "Ask for prayer", home_tile_prayer_text: "",
  home_tile_give_title: "Give generously", home_tile_give_text: "",
  home_tile_about_title: "Meet our pastors", home_tile_about_text: "",
  home_events_eyebrow: "Upcoming",
  home_events_headline: "Mark your calendar.",
  home_events_cta: "See all events",
  sermons_hero_image_url: "",
  sermons_eyebrow: "The Library",
  sermons_headline: "Sermons",
  sermons_intro: "",
  prayer_eyebrow: "A place to be carried",
  prayer_headline: "Send a prayer request.",
  prayer_intro: "",
  prayer_wall_eyebrow: "Prayer Wall",
  prayer_wall_headline: "Carried by the community.",
  prayer_wall_intro: "",
  give_eyebrow: "Ways to Give",
  give_headline: "Generosity is liturgy.",
  give_intro: "",
  give_fund_1_title: "General Fund", give_fund_1_text: "",
  give_fund_2_title: "Mercy Fund", give_fund_2_text: "",
  give_fund_3_title: "Missions", give_fund_3_text: "",
  give_disclaimer: "",
  events_eyebrow: "Calendar",
  events_headline: "What's happening at Sweet Embrace.",
  events_intro: "",
  contact_eyebrow: "Plan a visit",
  contact_headline: "Come as you are. We'll save you a seat.",
  contact_intro: "",
  visit_eyebrow: "Plan your visit",
  visit_headline: "Coming Sunday? Let's make it easy.",
  visit_intro: "",
  visit_perk_1_title: "Coffee on us", visit_perk_1_text: "",
  visit_perk_2_title: "Kids are celebrated", visit_perk_2_text: "",
  visit_perk_3_title: "~75 minutes", visit_perk_3_text: "",
  visit_form_disclaimer: "We never share your info. A pastor — not a bot — will email you back.",
  visit_submit_label: "Save my seat",
  visit_image_url: "",
};

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(FALLBACK);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings({ ...FALLBACK, ...data });
    } catch {
      /* keep fallback */
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <SettingsCtx.Provider value={{ settings, reload: load, setSettings }}>
      {children}
    </SettingsCtx.Provider>
  );
}

export const useSettings = () => useContext(SettingsCtx) || { settings: FALLBACK };
